import React from "react";
import { PulseLoader } from "react-spinners";

function CustomFeed({ streamData }) {
  ////console("streamData", streamData);
  const streams = Array.isArray(streamData) ? streamData : [streamData];

  return (
    <div className="content">
      {streams.length > 0 ? (
        <div className="streams-grid">
          {streams.map((ele) => (
            <div className="iframe-container" key={ele._id}>
              <h5>Camera ID: {ele.camera_id}</h5>
              <iframe
                src={ele.endpoint_url}
                title={`Camera Stream ${ele.camera_id}`}
                allow="autoplay; encrypted-media"
                frameBorder="0"
                className="camera-stream1"
              ></iframe>
            </div>
          ))}
        </div>
      ) : (
        // <p>No streams available</p>
        // <CustomButton className="btnSubmit py-2">
        <PulseLoader color="#313c41" />
        // </CustomButton>
      )}
    </div>
  );
}

export default CustomFeed;
